// Checks price using currency with fallback to non-multi currency
export function getExcursionPrice(excursion, type, selectedCurrency) {
    if (excursion.additionalPrice && excursion.additionalPrice.length > 0) {
        return excursion.additionalPrice.find((exc) => exc.currencySymbol === selectedCurrency)?.[type];
    }
    return excursion.price[type];
}

// Returns true if a valid adult or child price in multi currency/non-multi currency prices is found
export function checkExcursionPriceValidity(excursion) {
    let isMultiCurrencyPrice = false;
    if (excursion.additionalPrice && excursion.additionalPrice.length > 0) {
        isMultiCurrencyPrice = true;
    }
    const adultPrice = isMultiCurrencyPrice ? excursion.additionalPrice[0].adult : excursion.price.adult;
    const childPrice = isMultiCurrencyPrice ? excursion.additionalPrice[0].child : excursion.price.child;
    return (adultPrice !== undefined && adultPrice !== null) || (childPrice !== undefined && childPrice !== null)
}